import { useLocation } from "preact-iso";
import { useEffect, useState } from "preact/hooks";
import { setAuth, startAuthTransition, authLoading } from "../store/auth.js";
import { exchangeCode, getTokenExpiry } from "../auth/workos.js";

export default function Callback() {
  const { route } = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const urlError = params.get("error");
    const returnedState = params.get("state");

    if (urlError) {
      setError(urlError === "access_denied"
        ? "Access was denied. Please try again."
        : `Authentication error: ${urlError}`);
      return;
    }

    if (!code) {
      setError("No authorization code received.");
      return;
    }

    const expectedState = sessionStorage.getItem("oauth_state");
    sessionStorage.removeItem("oauth_state");
    if (!expectedState || returnedState !== expectedState) {
      setError("Login session expired or was tampered with. Please try again.");
      return;
    }

    startAuthTransition();

    void (async () => {
      try {
        const { accessToken, refreshToken, userId } = await exchangeCode(code);
        const expiresAt = getTokenExpiry(accessToken);
        setAuth({ userId, accessToken, refreshToken, expiresAt });
        route("/dashboard", true);
      } catch (err) {
        authLoading.value = false;
        setError(
          err instanceof Error ? err.message : "Login failed. Please try again.",
        );
      }
    })();
  }, []);

  if (error) {
    return (
      <div class="flex h-screen items-center justify-center">
        <div class="text-center max-w-sm">
          <p class="text-red-600 mb-4">{error}</p>
          <a href="/login" class="text-blue-600 hover:underline">
            Try again
          </a>
        </div>
      </div>
    );
  }

  return (
    <div class="flex h-screen items-center justify-center">
      <p class="text-gray-500">Processing login…</p>
    </div>
  );
}
